<template>
    <div class="d-day">
        <a href="https://www.johnnys-net.jp/page?id=artistTop&artist=10" target="_blank">
            <video autoplay loop muted playsinline width="450" height="360">
                <source src="@/assets/angel.mp4" type="video/mp4" />
            </video>
        </a>
        <div id="target-date" class="text" v-html="targetDateString"/>
        <div id="clock-area" :class="['text', {isOver: isOver}]" v-html="ddayString"/>
    </div>
</template>

<script>
export default {
    name: "d-day",
    data: function() {
        return {
            basisOffset: -540,
            targetDate: "January 1, 2021 00:00:00",
            // targetDate: "March 1, 2019 00:00:00",
            countDownTime: null,
            ddayString: '',
            interval: null,
            isOver: false,
            diff_m: 0,
        }
    },
    methods: {
        zf: function(n, width) {
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
        }
    },
    computed: {
        targetDateString: function() {
            return this.targetDate + ' UTC+09:00';
        }
    },
    created: function() {
        Date.prototype.setTimezoneOffset = function(minutes){
            let _minutes;
            if (this.timezoneOffset === _minutes) {
                _minutes = this.getTimezoneOffset();
            } else {
                _minutes = this.timezoneOffset;
            }
            if (arguments.length) {
                this.timezoneOffset = minutes;
            } else {
                this.timezoneOffset = minutes = this.getTimezoneOffset();
            }
            return this.setTime(this.getTime() + (_minutes - minutes) * 6e4);
        }

        const dday = new Date(this.targetDate);
        this.countDownTime = dday.getTime();
        
        const browseDay = new Date();
        const browseOffset = browseDay.getTimezoneOffset();
        this.diff_m = -(this.basisOffset-browseOffset);

        this.interval = setInterval(function() {
            const now = new Date().getTime();
            let distance = this.countDownTime - now;
            if ( this.countDownTime < now ) {
                this.isOver = true;
                distance = now - this.countDownTime;
            }
            distance = distance + (this.diff_m * 60 * 1000);
            const d = Math.floor(distance / (1000 * 60 * 60 * 24));
            const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const s = Math.floor((distance % (1000 * 60)) / 1000);
            let full = d+":"+this.zf(h,2)+":"+this.zf(m,2)+":"+this.zf(s,2);
            if ( !this.isOver && d <= 1) {
                full = '<font color=red>' + full + '</font>';
            }
            this.ddayString = full;
        }.bind(this), 50);
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
.d-day {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    flex-direction: column;
}
#clock-area {
    margin-top: 30px;
    font-size: 50px;
    letter-spacing: 2px;
}
.text {
    font-weight: bold;
}
@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
.isOver {
    animation: blink 2.3s infinite;
    color: $pantone-o;
}
</style>
